export default "/_next/static/chunks/fonts/pxiEyp8kv8JHgFVrJJnecmNE-2d053191b36dde4f2f903f6bd5cb5eec.woff2";